import { regions } from '@cmg/common';

export const isEmeaRegion = (region: string | null | undefined) => region === regions.EMEA;
